module.exports = __webpack_public_path__ + "img/logo-footer-2.b642f8dd.png";